import { render, staticRenderFns } from "./shippingWarehouseModal.vue?vue&type=template&id=4473780d&scoped=true"
import script from "./shippingWarehouseModal.vue?vue&type=script&lang=js"
export * from "./shippingWarehouseModal.vue?vue&type=script&lang=js"
import style0 from "./shippingWarehouseModal.vue?vue&type=style&index=0&id=4473780d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473780d",
  null
  
)

export default component.exports